import { useMemo } from 'react';
import { useSearchQuery } from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.hooks';
import getLang from 'I18n/utils/getLang';
export function useGetStorefrontListings({
  searchParams,
  skip
}) {
  const listingIdQuery = searchParams.searchBy === 'LISTING_ID' ? [{
    filtersByField: {
      LISTING_ID: [{
        __typename: 'com.hubspot.marketplace.search.models.filters.LongFilterQuery',
        values: searchParams.searchIds || [],
        negation: false,
        clause: 'OR'
      }]
    },
    clause: 'OR',
    negation: false
  }] : [];
  const sourceIdQuery = searchParams.searchBy === 'SOURCE_ID' ? [{
    filtersByField: {
      SOURCE_ID: [{
        __typename: 'com.hubspot.marketplace.search.models.filters.StringFilterQuery',
        values: searchParams.searchIds || [],
        negation: false,
        clause: 'OR'
      }]
    },
    clause: 'AND',
    negation: false
  }] : [];
  const {
    data,
    loading,
    error
  } = useSearchQuery({
    variables: {
      queryType: 'ELASTIC_SEARCH',
      language: getLang(),
      filter: {
        filterGroups: [...listingIdQuery, ...sourceIdQuery],
        clause: 'OR'
      }
    },
    skip: skip || !searchParams
  });
  const listingCards = useMemo(() => loading ? [] : data === null || data === void 0 ? void 0 : data.cards, [data === null || data === void 0 ? void 0 : data.cards, loading]);
  return {
    listingCards: listingCards || [],
    loading,
    error
  };
}